var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"btn-bg btn-round",on:{"click":_setup.onClick}},[_vm._t("default",function(){return [_c('span',{staticClass:"icon-ic-arrow-simple left"})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }